module.exports = __webpack_public_path__ + "static/media/Low.36cc8976.svg";